import { ConnectionNames } from "../Contracts";
import { QueryBuilder } from "./Helpers";
import { BaseRESTConnection } from "../Common";
export class CaptorConnection extends BaseRESTConnection {
    constructor(meta) {
        super(ConnectionNames.captor, meta);
        this.meta = meta;
    }
    reportsMetaData(q) {
        return this.applyQuery(QueryBuilder.reportsMetaData(q));
    }
    report(q) {
        return this.applyQuery(QueryBuilder.report(q));
    }
    annualReport(q) {
        return this.applyQuery(QueryBuilder.annualReport(q));
    }
}
//# sourceMappingURL=CaptorConnection.js.map